<template>
  <section>
    <VTitle text="AppTooltipElement" />
    <div class="example-component">
      <div class="example-component__controls">
        <VPropControl
          v-for="(propModel, propName) in propModels"
          :key="propName"
          :model="propModel"
          :name="propName"
        />
      </div>
      <div class="example-component__component">
        <AppTooltipElement
          :text="propModels.text.value"
          :placement="propModels.placement.value"
        />
      </div>
    </div>
  </section>
</template>

<script>
import AppTooltipElement from '@/components/UIKit/Standard/Atoms/AppTooltipElement'
import AppPropModel from '@/components/UIKit/Standard/ViewerSections/classes/AppPropModel'
import VTitle from '@/components/UIKit/Standard/ViewerSections/components/snippets/VTitle'
import VPropControl from '@/components/UIKit/Standard/ViewerSections/components/snippets/VPropControl'
import tooltipPlacements from '@/constants/ui-kit/standard/tooltip-placements'

export default {
  name: 'AppTooltipElementViewer',
  components: {
    AppTooltipElement,
    VTitle,
    VPropControl,
  },
  data() {
    return {
      propModels: {
        text: new AppPropModel({
          type: String,
          defaultValue: 'Tooltip text',
          required: true,
        }),
        placement: new AppPropModel({
          type: String,
        }),
      },
    }
  },
  created() {
    Object.keys(tooltipPlacements).forEach((placement) => {
      this.propModels.placement.addPreset(
        tooltipPlacements[placement],
        placement
      )
    })
  },
}
</script>

<style lang="scss" scoped>
.example-component {
  display: flex;
  justify-content: stretch;
  align-items: stretch;

  @at-root &__controls {
    background: #fff;
    padding: 30px;
    border: 1px solid var(--gray-200);
    flex-basis: 300px;
    border-radius: 12px;
  }

  @at-root &__component {
    padding: 30px;
    flex: 1;
  }
}
</style>
